import {Lottie} from '~/view_invitation_premium/react-lottie';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';
import desktop from './confetti_ani_desktop.json';
import mobile from './confetti_ani_mobile.json';
import './ConfettiAnimation.sass';

const defaultOptions = {
  loop: false,
  autoplay: true,
  renderer: 'svg',
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid meet',
  },
};

export const ConfettiAnimation = ({height = '100vh', width = '100vw'}) => {
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  return (
    <Lottie
      options={{...defaultOptions, animationData: isDesktop ? desktop : mobile}}
      height={height}
      width={width}
      isStopped={false}
      isPaused={false}
      isClickToPauseDisabled
      className="confetti-animation"
    />
  );
};

// This is the length of the animation in milliseconds
export const animationLength = 4800;
